'use strict';
const moment = require('moment');
const _ = require('lodash');

module.exports = function (start, end, round = 'minute') {
  if (!start || !end) {
    return '';
  }

  if (round === 'weeks') {
    return '';
  }

  if (!moment.isMoment(start)) {
    start = moment.utc(start);
  }

  if (!moment.isMoment(end)) {
    end = moment.utc(end);
  }

  if (end < start) {
    end.add(1, 'd');
  }

  const duration = moment.duration(end.diff(start, round), round);
  const years = duration.get('years');
  const months = duration.get('months');
  const days = duration.get('days');
  const hours = duration.get('hours');
  const minutes = duration.get('minutes');
  let display = '';

  if (years > 0) {
    display += years + ' jaar ';
  }

  if (months === 1) {
    display += months + ' maand ';
  } else if (months > 1) {
    display += months + ' maanden ';
  }

  if (days === 1) {
    display += days + ' dag ';
  } else if (days > 1) {
    display += days + ' dagen ';
  }

  if (hours > 0) {
    display += hours + ' uur ';
  }

  if ((days > 0 || hours > 0) && minutes > 0) {
    display += 'en ';
  }

  if (minutes === 1) {
    display += minutes + ' minuut';
  } else if (minutes > 1) {
    display += minutes + ' minuten';
  }

  return _.trim(display);
};
